export default "__VITE_ASSET__jk7m6QzK__"